import styled from "styled-components";
import colors from "../../../../styles/colors";
import fontSizes from "../../../../styles/fontSizes";

export const ButtonsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  border: solid 0.1rem ${colors.darkgrey};
  border-radius: 0.5rem;
  padding: 0.25rem;
  margin: 0px auto;
  font: inherit;
`;

export const AlignmentButton = styled.button`
  border: solid 1px ${colors.lightgrey};
  margin-right: 0.5rem;
  border-radius: 0.5rem;
  &: hover {
    border: solid 1px ${colors.darkgrey};
    background: ${colors.lightgrey};
    cursor: pointer;
  }
  font-size: ${fontSizes.regular};
`;
